/**
 * Proveedores GraphQL Mutations
 * Mutations reales del backend de FinancialService
 */

/** MUTATIONS PARA ADMIN */

export const createProviderAdmin = `
    mutation createProvider($provider: inputProviderAdmin!){
        createProvider(provider: $provider){
          id,
        }
      }
`;

export const updateProviderAdmin = `
    mutation updateProvider($id:String!,$provider: inputProviderAdmin!){
        updateProvider(id:$id,provider: $provider){
          id,
        }
      }
`;

export const deleteProviderAdmin = `
    mutation deleteProvider($id:String!){
        deleteProvider(id:$id){
          id,
        }
      }
`;